import React from "react";
import { Assets } from "../../assets";
import { useLoader } from "../../hooks/animation/useLoader";

export const Loader = ({ backgroundImage = `bg-viewGeneral` }) => {
	const { loader } = useLoader();
	return (
		<>
			<div ref={loader} className="absolute h-full w-full z-40">
				<div
					className={`relative h-full w-full ${backgroundImage} bg-center bg-no-repeat xsm:bg-cover lg:bg-auto flex justify-center items-center`}
				>
					<div id="gradiantBackground" className={`absolute css-gradiant-loader z-10 h-full w-full`} />
					<div id="loaderLogos" className=" text-white flex flex-col justify-center items-center">
						<div id="imageLoader" className="xsm:w-[78px] lg:w-[245px]">
							<img className="h-full w-full" src={Assets.general.logo} alt="logo" />
						</div>
						<div className="flex justify-center items-center flex-col">
							<p className="xsm:text-[12px] lg:text-[16px] font-bold arialFont">Casa abierta al tiempo</p>
							<p className="uppercase font-bold xsm:text-[15px] lg:text-[40px] arialFont">UNIVERSIDAD AUTÓNOMA METROPOLITANA</p>
							<p className="capitalize font-bold xsm:text-[12px] lg:text-[20px] arialFont">Unidad xochimilco</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
